var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightRays(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Light_Beams",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1296 1296",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: url(#radial-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 654.4,
    cy: 638.5,
    fx: 654.4,
    fy: 638.5,
    r: 591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M644.9,639.3L443,32.3l-66.5,26.3,267.4,581.1c.3-.1.6-.3.9-.4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M638.8,648c0-.2,0-.5,0-.7L0,612.3v71.6l638.7-35.5c0-.1,0-.3,0-.4Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M641.7,641.3L215.1,164.4l-50.6,50.6,476.5,427c.2-.3.5-.5.7-.7Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M639.5,644.3L58.5,376.4l-26.2,66.6,606.9,202.3c.1-.3.2-.7.4-1Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M656.8,645.3l606.9-202.3-26.3-66.5-580.9,267.9c.1.3.2.6.3.9Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M655,642l476.4-426.9-50.6-50.6-426.5,476.8c.2.2.5.5.7.7Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M652,639.7L919.6,58.6l-66.6-26.3-201.8,607.1c.3.1.6.2.8.4Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M648,638.8c.1,0,.2,0,.3,0L683.8,0h-71.6l35,638.8c.3,0,.5,0,.8,0Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M639.4,651.3L32.3,853l26.3,66.5,581.1-267.4c-.1-.3-.2-.5-.4-.8Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M654,655l426.9,476.4,50.6-50.6-476.8-426.5c-.2.2-.5.5-.7.7Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M657.2,647.2c0,.3,0,.5,0,.8s0,.2,0,.3l638.8,35.5v-71.6l-638.8,35Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M650.8,656.8l202.2,606.9,66.5-26.3-267.9-580.9c-.3.1-.6.2-.9.3Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M656.3,652l581.1,267.5,26.3-66.5-607.1-201.8c-.1.3-.2.6-.4.8Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M641.3,654.3l-476.9,426.6,50.6,50.6,427-476.5c-.3-.2-.5-.5-.7-.7Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M648,657.2c-.3,0-.5,0-.8,0l-35,638.8h71.6l-35.5-638.8c-.1,0-.2,0-.3,0Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M644.3,656.5l-267.9,581,66.5,26.3,202.4-607c-.3,0-.6-.2-.9-.4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightRays);
export default __webpack_public_path__ + "static/media/light-rays.dc7285dad32c5ca520bb2a1f5d8d656d.svg";
export { ForwardRef as ReactComponent };